import { Injectable } from '@angular/core';
import { AlertController } from 'ionic-angular';

@Injectable()
export class AlertService {
  constructor(private alertCtrl: AlertController) { }

  public alert(opts: any) {
    let a = this.alertCtrl.create(opts);
    a.present();
    return a;
  }

  public showAlert(msg: string, title: string = "提示", isauto = true) {
    if (this.isHidden()) {
      return;
    }
    let alert = this.alertCtrl.create({
      title: title,
      subTitle: msg,
      buttons: [
        {
          text: '确认',
          // handler: data => {
          //     alert.dismiss();
          // }
        }
      ]
    });
    alert.present();
    if (isauto) {
      setTimeout(function () {
        alert.dismiss();
      }, 3000);
    }
  }
  public errorAlert(msg: string) {
    this.showAlert(msg);
  }
  public shownewAlert(msg: string, title: string = "提示", isauto = true, callback?: Function) {
    if (this.isHidden()) {
      return;
    }
    let alert = this.alertCtrl.create({
      title: title,
      message: msg,
      buttons: [
        {
          text: '确认',
          handler: data => {
            if (callback) {
              callback(data);
            }
          }
        }
      ]
    });
    alert.present();
    if (isauto) {
      setTimeout(function () {
        alert.dismiss();
      }, 3000);
    }
  }
  showConfirm(msg: string, callback: Function, title: string = "提示", cancelFun: Function = null, enableBackdropDismiss = false) {
    let alert = this.alertCtrl.create({
      title: title,
      message: msg,
      buttons: [
        {
          text: '取消',
          handler: () => {
            // alert.dismiss();
            if (cancelFun) {
              cancelFun();
            }
          }
        },
        {
          text: '确认',
          handler: () => {
            // alert.dismiss();
            callback();
          }
        }
      ],
      enableBackdropDismiss: enableBackdropDismiss
    });
    alert.present();
  }
  showConfirms(msg: string, callback: Function, title: string = "提示", cancelFun: Function = null, enableBackdropDismiss = false) {
    let alert = this.alertCtrl.create({
      title: title,
      message: msg,
      buttons: [
        {
          text: '确认',
          handler: () => {
            // alert.dismiss();
            callback();
          }
        }
      ],
      enableBackdropDismiss: enableBackdropDismiss
    });
    alert.present();
  }
  showConfirmse(msg: string, callback: Function, title: string = "温馨提示", cancelFun: Function = null, enableBackdropDismiss = true) {
    let alert = this.alertCtrl.create({
      title: title,
      message: msg,
      buttons: [
        {
          text: '确认修改',
          handler: () => {
            // alert.dismiss();
            callback();
          }
        }
      ],
      enableBackdropDismiss: enableBackdropDismiss
    });
    alert.present();
  }
  getHiddenProp() {
    var prefixes = ['webkit', 'moz', 'ms', 'o'];

    // if 'hidden' is natively supported just return it
    if ('hidden' in document) return 'hidden';

    // otherwise loop over all the known prefixes until we find one
    for (var i = 0; i < prefixes.length; i++) {
      if ((prefixes[i] + 'Hidden') in document)
        return prefixes[i] + 'Hidden';
    }

    // otherwise it's not supported
    return null;
  }
  isHidden() {
    var prop = this.getHiddenProp();
    if (!prop) return false;

    return document[prop];
  }




  registerAlert(msg: string, callback: Function, title: string = "提示", cancelFun: Function = null, enableBackdropDismiss = true) {
    let alert = this.alertCtrl.create({
      title: title,
      message: msg,
      buttons: [

        {
          text: '确认',
          handler: () => {
            // alert.dismiss();
            callback();
          }
        }
      ],
      enableBackdropDismiss: enableBackdropDismiss
    });
    alert.present();
  }
}




// WEBPACK FOOTER //
// ./src/providers/alert.service.ts